module.exports = __webpack_public_path__ + "static/partner-0da9d6fad98320d4732fa434401a3634.jpg";